export const env = import.meta.env.VITE_ENVIRONMENT;
export const isProduction = env === 'production';
export const isLocal = env === 'local';
export const apiUrl = import.meta.env.VITE_API_URL;
export const cueingAppUrl = import.meta.env.VITE_CUEING_APP_URL;
export const apiTimeout = import.meta.env.VITE_API_TIMEOUT
  ? parseInt(import.meta.env.VITE_API_TIMEOUT, 10)
  : undefined;
export const completeFileUploadTimeout = import.meta.env.VITE_COMPLETE_FILE_UPLOAD_TIMEOUT
  ? parseInt(import.meta.env.VITE_COMPLETE_FILE_UPLOAD_TIMEOUT, 10)
  : undefined;
